import { RouteComponentProps, withRouter } from "react-router-dom";
import * as React from "react";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import QuotesTable from "./QuotesTable";

function GerencialQuotes(
  props: RouteComponentProps<any> & {
    style?: React.CSSProperties;
    tableProps: { style: React.CSSProperties };
  }
) {
  return (
    <PbrCard title={`Cotações Realizadas`} bordered={false} style={{ width: "100%" }}>
      <QuotesTable {...props.tableProps} />
    </PbrCard>
  );
}

export default withRouter(GerencialQuotes);



// WEBPACK FOOTER //
// ./src/pages/gerencial/quotes/GerencialQuotes.tsx